import React from "react";

import { Heading } from "@bps/fluent-ui";
import { FieldDevice } from "@libs/api/gateways/field/field-ops-gateway.dtos";
import { ChangeLog } from "@libs/api/types/common-dtos";

import { DeviceSettingsFilter } from "./DeviceSettingsFilter";
import { DeviceSettingsTable } from "./DeviceSettingsTable";

export interface DeviceSettingRowDto {
  id: string;
  fieldDeviceId: string;
  fieldDeviceSettingType: string;
  settingTypeDescription: string;
  value: string;
  eTag: string;
  changeLog: ChangeLog;
}

interface DeviceSettingsProps {
  device: FieldDevice;
}

export const DeviceSettings: React.FC<DeviceSettingsProps> = ({ device }) => {
  return (
    <>
      <Heading variant="section-heading">Settings</Heading>

      <DeviceSettingsFilter>
        {({ values }) => {
          return <DeviceSettingsTable deviceId={device.id} filter={values} />;
        }}
      </DeviceSettingsFilter>
    </>
  );
};
